import React, { useState, useContext } from 'react';
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { Email, Lock } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { AuthContext } from '../context/AuthContext';

export default function Login() {
  const { setUserTipo, setUsername, setPodeUsarKitBlindagem } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    localStorage.clear();

    try {
      const response = await api.post('/auth/login', { email, senha });

      if (response.data && response.data.token) {
        const usuario = response.data.usuario;

        // **Só permite admin ou revendedor**
        if (usuario.tipo !== 'admin' && usuario.tipo !== 'revendedor') {
          setErro('Login permitido apenas para administradores ou revendedores.');
          setLoading(false);
          return;
        }

        // Salva dados no localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', usuario.nome);
        localStorage.setItem('tipo', usuario.tipo);
        localStorage.setItem('id_usuario', usuario.id);
        localStorage.setItem('chave_usuario', usuario.chave || '');
        localStorage.setItem(
          'pode_usar_kit_blindagem',
          usuario.pode_usar_kit_blindagem ? '1' : '0'
        );
        localStorage.setItem('pode_usar_flow', usuario.pode_usar_flow ? '1' : '0');
        localStorage.setItem('data_vencimento', usuario.data_vencimento || '');

        setUserTipo(usuario.tipo);
        setUsername(usuario.nome);
        setPodeUsarKitBlindagem(!!usuario.pode_usar_kit_blindagem);

        navigate('/dashboard');
      } else {
        setErro(response.data?.erro || 'E-mail ou senha inválidos.');
      }
    } catch (err) {
      setErro(
        err?.response?.data?.erro ||
          err?.message ||
          'Não foi possível entrar. Tente novamente.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .fadeError {
            opacity: 1;
            transition: opacity 0.4s ease-in-out;
          }
          .fadeError.hidden {
            opacity: 0;
            height: 0;
            margin: 0;
            padding: 0;
            overflow: hidden;
          }
        `}
      </style>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        sx={{
          background: 'linear-gradient(270deg, #2196f3, #ffeb3b, #2196f3)',
          backgroundSize: '600% 600%',
          animation: 'gradientShift 12s ease infinite',
          padding: { xs: 2, sm: 4 },
        }}
      >
        <Paper
          elevation={6}
          sx={{
            padding: { xs: 3, sm: 5 },
            width: '100%',
            maxWidth: 400,
            borderRadius: 3,
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ fontWeight: 'bold', mb: 3 }}
          >
            Bem-vindo de Volta!
          </Typography>

          <form onSubmit={handleLogin}>
            <TextField
              label="E-mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              margin="normal"
              required
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email />
                  </InputAdornment>
                ),
              }}
              disabled={loading}
            />

            <TextField
              label="Senha"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              fullWidth
              margin="normal"
              required
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              }}
              disabled={loading}
            />

            {/* Link Esqueci minha senha */}
            <Box sx={{ mt: 1, mb: 1, textAlign: 'right' }}>
              <Button
                type="button"
                size="small"
                variant="text"
                onClick={() => navigate('/esqueci-senha')}
                disabled={loading}
              >
                Esqueci minha senha
              </Button>
            </Box>

            <Typography
              color="error"
              variant="body2"
              sx={{ mt: 1, mb: 1 }}
              className={erro ? 'fadeError' : 'fadeError hidden'}
            >
              {erro}
            </Typography>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1, py: 1.5, fontWeight: 'bold', fontSize: 16 }}
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? 'Entrando...' : 'ENTRAR'}
            </Button>
          </form>
        </Paper>
      </Box>
    </>
  );
}
